import React, { FC, memo } from 'react'
import SC from '../base/Aside.styles'
import { IAsideProps } from '../types'
import { Sticky } from '../../Sticky'

const { Block } = SC

/** Компонент-контейнер для боковой колонки */
const Aside: FC<IAsideProps> = (props) => {
  const { indentSide = 'left', children } = props

  return (
    <Sticky options={{ topSpacing: 32, bottomSpacing: 32 }}>
      <Block indentSide={indentSide}>{children}</Block>
    </Sticky>
  )
}

export { Aside }
export default memo(Aside)
